var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.563 11.587c2.22 6.84-.277 14.519-6.102 18.707a16.35 16.35 0 0 1-19.556 0C1.08 25.966-1.417 18.428.802 11.587 3.16 4.607 9.54 0 16.752 0s13.592 4.607 15.811 11.587zM16.752 1.536c-6.519 0-12.344 4.188-14.424 10.47-2.08 6.282.139 13.123 5.548 17.032a14.904 14.904 0 0 0 17.752 0c5.27-3.91 7.49-10.75 5.548-17.032-2.08-6.282-7.905-10.47-14.424-10.47z",
    fill: "#313546"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.971 11.866h1.526V9.493c-.278 0-.555 0-.694-.14h-1.387c-.693 0-1.387.14-1.941.559-.694.698-1.11 1.256-1.249 2.094 0 .28-.138.698-.138.977V14.66h-2.22v2.652h2.22v6.561h2.774v-6.561h2.219c.138-.838.277-1.815.277-2.653H17.723v-1.814c.139-.698.693-.838 1.248-.978z",
    fill: "#313546"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookBlack);
export default __webpack_public_path__ + "static/media/facebookBlack.22b3cdac19d25b04bd247644f86a5a33.svg";
export { ForwardRef as ReactComponent };